import { Component, OnInit } from "@angular/core";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import * as SecureLS from "secure-ls";
import { FormBuilder, FormGroup } from "@angular/forms";
import { CommonService } from "src/app/services/common.service";
import { StorageService } from "src/app/services/storage.service";
import { ExcelServicesService } from "src/app/services/excel.service";
import { ErrorModalComponent } from "../error-modal/error-modal.component";
import CryptoJS from "crypto-js";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-approved-videos",
  templateUrl: "./approved-videos.component.html",
  styleUrls: ["./approved-videos.component.css"],
})
export class ApprovedVideosComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  total_count = 0;
  cam: any[];
  videoList: any[] = [];
  downloadVideoList: any;
  filter_from: any;
  filter_end: any;
  page: number = 1;
  page_size: number = 10;
  video_message: string;
  error_message: any;
  department_id: any;
  currentPage: number = 1;
  pageSize: number = 10;
  dept: any;
  classData: any;
  batchData: any;
  subjectData: any;
  searchForm: FormGroup;
  maxDate: Date;
  professorData: any;
  dropbox: Array<Object> = [];
  recrange: any;
  pageno: any;
  chiparray: any = [];
  role: any;
  ishod: any;
  sessionData: any;
  minDate: Date;
  findedVal: any;
  batch_id: any;
  professor_id: any;
  subject_id: any;
  classroom_id: any;
  isAudiable: any;
  isSixRoleId: any;
  audio_availability: any;
  isActive: any;
  viderror: Object;
  errstatus: any;
  isNonNumeric: boolean;
  numericError: boolean;
  constructor(
    private storageService: StorageService,
    public globalService: GlobalService,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private ExcelServicesService: ExcelServicesService,
    public commonService: CommonService,
    private route: ActivatedRoute
  ) {
    this.role = this.storageService.getRole();
    this.ishod = this.storageService.getHod();
  }

  async ngOnInit() {
    this.maxDate = new Date();
    this.minDate = new Date();
    this.maxDate.setDate(this.maxDate.getDate() - 1);
    this.searchForm = this.fb.group({
      id: [""],
      date: [null],
      status_message: [null],
      error_message: [null],
      proname: [null],
      depname: [null],
      batchname: [null],
      class_name: [null],
      sub_name: [null],
      isAudiable: [null],
      audio_availability: [null],
      session: [null],
    });
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      this.department_id = this.storageService.getDepartment();
      this.searchForm.controls["depname"].setValue(
        this.department_id
      );     
      this.searchForm.controls["depname"].disable();
    }

    if (this.storageService.getRole() == 4 && this.ishod !== 1) {
      this.professor_id = this.storageService.getProfessor();
      this.searchForm.controls["proname"].setValue(this.professor_id);
      this.searchForm.controls["proname"].disable();
    }
    await this.getAllDropdownData();
  }
  get searchFormCtrl() {
    return this.searchForm.controls;
  }

  getvalue(event: any, rec: any) {
    this.spinner.show();
    this.recrange = rec;
    this.pageno = event;
    this.exportAsXLSX();
  }

  async getAllDropdownData() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };
    let video = await this.globalService.get(
      "classVideoDetail/list/dropdown/schedule-status",
      filter
    );
    this.cam = video["content"];
    
    this.viderror = await this.globalService.get(
      "classVideoDetail/list/dropdown/error-schedule-status",
      filter
    );

    this.errstatus = this.viderror["content"];

    let department = await this.globalService.get(
      "department/list/dropdown",
      filter,
      true
    );

    this.dept = department["content"];
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      this.searchForm.controls["depname"].patchValue(
        this.storageService.getDepartment()
      );
    }
    let session = await this.globalService.get(
      "session/dropdown",
      filter,
      true
    );

    this.sessionData = session["content"];
    this.setCurrentSessionInForm();
    let professorname = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professorname["content"];

    let classroom = await this.globalService.get(
      "classroom/list/dropdown",
      filter,
      true
    );

    this.classData = classroom["content"];
    let batch = await this.globalService.get(
      "batch/list/dropdown",
      filter,
      true
    );

    this.batchData = batch["content"];
    let subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"];
    this.onApplyFilter();
    this.spinner.hide();
  }

  async dropboxdown() {
    this.dropbox = [];
    var count = 1000,
      tempcount = 1000,
      c1,
      c2;
    let check = Math.ceil(this.total_count / count);
    var cvar = 1;
    for (let i = 1; i <= check; i++) {
      c1 = cvar;
      c2 = count;
      cvar = cvar + tempcount;
      count += tempcount;
      this.dropbox.push({ value: i, records: c1 + "-" + c2 });
    }
  }

  async onSessionChangeEvent(isInitLoad?) {
    this.searchFormCtrl["date"].setValue(null);
    this.getFilterDate(null);
    let sessionVal = this.searchFormCtrl["session"].value;
    if (sessionVal) {
      this.findedVal = this.sessionData.find(
        (list) => list.session === sessionVal
      );
      await this.getSubjectDropdown();
      this.minDate.setDate(new Date(this.findedVal.start_date).getDate());
      this.minDate.setMonth(new Date(this.findedVal.start_date).getMonth());
      this.minDate.setFullYear(
        new Date(this.findedVal.start_date).getFullYear()
      );
      this.maxDate.setDate(new Date(this.findedVal.end_date).getDate());
      this.maxDate.setMonth(new Date(this.findedVal.end_date).getMonth());
      this.maxDate.setFullYear(new Date(this.findedVal.end_date).getFullYear());
      if (isInitLoad) {
        let splitedChipArray = null;
        if(this.chiparray.length){
          this.chiparray.forEach((elem)=>{
            if(elem.split(" : ")[0] === "Date" ){
              splitedChipArray =  elem.split(" : ")[1].split(" - ");
            }
          })
        }
        if (splitedChipArray?.length) {
          const convertedDates = splitedChipArray.map(dateStr => new Date(dateStr));
          this.searchFormCtrl["date"].setValue(convertedDates);
          this.getFilterDate(convertedDates);
        } else {
          const today = new Date();
          this.searchFormCtrl["date"].setValue([today, today]);
          this.getFilterDate([today, today]);
        }
      }
    } else {
      this.searchFormCtrl["date"].setValue(null);
      this.getFilterDate(null);
    }
  }

  async onDepartmentChange() {
    await this.getSubjectDropdown();
    await this.getProfessorDropdown();
  }

    async getProfessorDropdown() {
    this.spinner.show();

    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    const departmentId = this.searchForm.get("depname")?.value;

    if (departmentId) {
      filter.department_id = departmentId;
    }

    const professor = await this.globalService.get(
      "user/profeser/dropdown",
      filter,
      true
    );

    this.professorData = professor["content"] || [];

    // Clear selected professor after department changes
    this.searchForm.patchValue({
      proname: null,
    });
    this.professor_id = null;

    this.spinner.hide();
  }

  async getSubjectDropdown() {
    const filter: any = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
    };

    if (this.findedVal?.id) {
      filter.session_id = this.findedVal.id;
    }

    const departmentId = this.searchForm.get("depname")?.value;
    if (departmentId) {
      filter.department_id = departmentId;
    }

    const subject = await this.globalService.get(
      "subject/list/dropdown",
      filter,
      true
    );

    this.subjectData = subject["content"] || [];

    // Clear previously selected subject if needed
    this.searchForm.patchValue({
      sub_name: null,
    });
  }

  getFilterDate(filter_date) {
    if (filter_date) {
      this.filter_from = moment(filter_date[0]).format("YYYY-MM-DD");
      this.filter_end = moment(filter_date[1]).format("YYYY-MM-DD");
      var oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay; // hours*minutes*seconds*milliseconds
      var diffDays =
        Math.floor(
          new Date(this.filter_from).getTime() -
            new Date(this.filter_end).getTime()
        ) / oneDay;
      if (-diffDays > 180) {
        Swal.fire({
          text: "Please select dates within 180 days",
          icon: "warning",
          confirmButtonText: "OK",
          confirmButtonColor: "#808080",
        });
        this.searchForm.controls["date"].setValue("");  
      }
    } else {
      this.filter_from = "";
      this.filter_end = "";
    }
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(
      dateValue,
      timeValue,
      isDateRequested
    );
  }
  async getPage(page: number) {
    this.currentPage = page;
    this.getVideoDetails();
  }

  getVideoDetails() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      page: this.currentPage,
      page_size: this.page_size,
      video_status_id: this.video_message,
      error_status_id: this.error_message,
      department_id: this.department_id?this.department_id: this.searchForm.controls["depname"].value,
      batch_id: this.batch_id,
      subject_id: this.subject_id,
      classroom_id: this.classroom_id,
      professor_id: this.professor_id? this.professor_id : this.searchForm.controls["proname"].value,
      has_audio: this.isAudiable,
      audio_availability: !this.isSixRoleId ? this.audio_availability : 50,
      is_active: this.isActive,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      session_id: this.findedVal?.id,
    };
    if((this.filter_from != null && this.filter_from != "" ) && (this.filter_end != null && this.filter_end != "" ))
    {
      const dateKeyExists = this.chiparray.some((chip) => chip.startsWith("Date :"));

    if (!dateKeyExists) {
      this.chiparray.push("Date :" + " " + filter.camera_start + " - " + filter.camera_end);
    }
  }

    this.globalService
      .get("classVideoDetail/get-approved-videodetails", filter)
      .then((data) => {
        let getVideo = data;
        this.videoList = getVideo["content"]["rows"];

        if (getVideo["status"] === 200) {
          this.videoList = getVideo["content"]["rows"];
          this.total_count = getVideo["content"].count;
        }
      });
    this.dropboxdown();
    this.spinner.hide();
  }
  async videoenc(id, hlsStatus) {
    const encrypt = (text) => {
      return CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(text));
    };
    const enryptText = hlsStatus == "0" ? "ZERO" : "ONE";
    let key = id;
    if (this.route.queryParams["value"].loginType == "impersonate") {
      window.open(
        `/video/play?key=${key}&loginType=impersonate&isHls=${encrypt(
          enryptText
        )}`,
        "_blank"
      );
    } else {
      window.open(
        `/video/play?key=${key}&isHls=${encrypt(enryptText)}`,
        "_blank"
      );
    }
  }
  async exportAsXLSX(): Promise<void> {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      role_id: this.storageService.getRole(),
      department_id: this.searchForm.controls["depname"].value,
      batch_id: this.searchForm.controls["batchname"].value,
      subject_id: this.searchForm.controls["sub_name"].value,
      classroom_id: this.searchForm.controls["class_name"].value,
      professor_id: this.searchForm.controls["proname"].value,
      page: this.total_count > 1000 ? this.pageno : 1,
      page_size: 1000,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      session_id: this.findedVal?.id,
    };
    let getVideo = await this.globalService.get(
      "classVideoDetail/get-approved-videodetails",
      filter
    );

    let excelVideoList = getVideo["content"]["rows"];
    var startTM;
    var endTM;
    excelVideoList.forEach((e, i) => {
      startTM = this.commonService.getUtcTimeToLocale(
        excelVideoList[i].start_date,
        excelVideoList[i].start_time,
        ""
      );
      excelVideoList[i]["start_time"] = startTM;
      endTM = this.commonService.getUtcTimeToLocale(
        excelVideoList[i].end_date,
        excelVideoList[i].end_time,
        ""
      );
      excelVideoList[i]["end_time"] = endTM;

      // if (!excelVideoList[i].camera_start || excelVideoList[i].camera_start.trim() === '') {
      //   excelVideoList[i]["camera_start"] = "Data Unavailable";
      // }

      // if (!excelVideoList[i].camera_end || excelVideoList[i].camera_end.trim() === '') {
      //   excelVideoList[i]["camera_end"] = "Data Unavailable";
      // }
    });
    this.downloadVideoList = excelVideoList.map((item: any) => {
      const formattedCameraStart = item.login_at
        ? new Date(item.camera_start).toLocaleString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          })
        : "";
      const formattedCameraEnd = item.login_at
        ? new Date(item.camera_end).toLocaleString("en-US", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
            hour12: true,
          })
        : "";
      return {
        SUBJECT_NAME: item.subject_details?.name,
        DEPARTMENT_NAME: item.department_details?.name,
        BATCH: item.batch_details?.batch,
        PROFESSOR_NAME: item.professor_details
          ? item.professor_details.first_name + item.professor_details.last_name
          : "",
        CLASS_ROOM_NAME: item.classroom_details?.name,
        STATUS_MESSAGE: item.VideoStatus.status_message,
        STARTDATE: item.start_date,
        END_DATE: item.end_date,
        CAMERA_START: formattedCameraStart,
        CAMERA_END: formattedCameraEnd,
        START_TIME: item.start_time,
        END_TIME: item.end_time,
      };
    });

    this.ExcelServicesService.exportAsExcelFile(
      this.downloadVideoList,
      "Approved Video report" + " " + [this.recrange]
    );
    this.recrange = "";
    this.total_count = getVideo["content"].count;
    this.spinner.hide();
  }

  loadMore(index) {
    this.currentPage = index;
    this.getVideoDetails();
  }
  previous() {
    this.currentPage = this.currentPage - 1;
    this.getVideoDetails();
  }
  next() {
    this.currentPage = this.currentPage + 1;
    this.getVideoDetails();
  }

  openScrollableContent(longContent) {
    if (this.ls.get("token")) {
      this.modalService.open(longContent, { scrollable: true });
    }
    if(!this.searchForm.controls["session"].value){
    this.searchForm.controls["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );}
    if (this.storageService.getRole() === 4 && this.ishod == 1) {
      this.searchForm.controls["depname"].setValue(
        this.storageService.getDepartment()
      );
      this.searchForm.controls["depname"].disable();
    }
    if (this.storageService.getRole() === 4 && this.ishod !== 1) {
      this.searchForm.controls["proname"].setValue(
        this.storageService.getProfessor()
      );
      this.searchForm.controls["proname"].patchValue(
        this.storageService.getProfessor()
      );
      this.searchForm.controls["proname"].disable();
    }
    this.onSessionChangeEvent(true);
  }

  setCurrentSessionInForm() {
    this.searchFormCtrl["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.onSessionChangeEvent(true);
  }

  openErrorModal(errMsg, id) {
    if (errMsg) {
      const errorModalComp = this.modalService.open(ErrorModalComponent, {
        scrollable: true,
        size: "lg",
      });
      errorModalComp.componentInstance.id = id;
      errorModalComp.componentInstance.errMsg = errMsg
        ? errMsg
        : "--No Error Message--";
    }
  }

  async onApplyFilter() {
    this.currentPage = 1;
    this.chiparray = [];
    this.department_id =  this.department_id ? this.department_id : this.searchForm.controls["depname"]?.value;
    this.subject_id = this.searchForm.controls['sub_name']?.value;
    this.classroom_id = this.searchForm.controls['class_name']?.value;
    this.batch_id = this.searchForm.controls['batchname']?.value;
    this.video_message =this.searchForm.controls['status_message']?.value;
      this.error_message = this.searchForm.controls['error_message']?.value;
    this.findedVal = this.sessionData.find(
      (list) => list.session === this.searchFormCtrl["session"]?.value
    );
    if (this.searchForm.controls["session"]?.value) {
      this.chiparray.push(
        "Session : " + this.searchForm.controls["session"]?.value
      );
    }
    if (this.searchForm.controls["status_message"]?.value) {
      var vidmsg = this.cam.filter((x) => x.id == this.searchForm.controls["status_message"]?.value);
      this.chiparray.push("Vidmsg:" + " " + vidmsg[0].status_message);
    }
    if (this.searchForm.controls["error_message"]?.value) {
      var errmsg = this.errstatus.filter((x) => x.id == this.searchForm.controls["error_message"]?.value);
      this.chiparray.push("Errmsg :" + " " + errmsg[0].status_message);
    }

    if (this.searchForm.controls["proname"]?.value) {
      var proffessor = this.professorData.filter(
        (x) => x.id == this.searchForm.controls["proname"]?.value
      );
      if (proffessor.length > 0 && proffessor[0]) {
        this.chiparray.push(
          "Proff:" +
            " " +
            proffessor[0].first_name +
            " " +
            proffessor[0].last_name
        );
      }
    }

    if (this.searchForm.controls["depname"]?.value) {
      var dept = this.dept.filter(
        (x) => x.id == this.searchForm.controls["depname"]?.value
      );
      this.chiparray.push("Dept:" + " " + dept[0].name);
    }

    if (this.searchForm.controls["sub_name"]?.value) {
      var subject = this.subjectData.filter(
        (x) => x.id == this.searchForm.controls["sub_name"]?.value
      );
      this.chiparray.push("Subject:" + " " + subject[0].name);
    }

    if (this.searchForm.controls["batchname"]?.value) {
      var batch = this.batchData.filter(
        (x) => x.id == this.searchForm.controls["batchname"]?.value
      );
      this.chiparray.push("Batch:" + " " + batch[0].batch);
    }

    if (this.searchForm.controls["class_name"]?.value) {
      var classroom = this.classData.filter(
        (x) => x.id == this.searchForm.controls["class_name"]?.value
      );
      this.chiparray.push("Class:" + " " + classroom[0].name);
    }
    
    if(this.searchForm.controls['audio_availability']?.value) {
      this.chiparray.push(
        "Audio Availability : " + this.searchForm.controls['audio_availability']?.value
      );
    }
    await this.getVideoDetails();
  }

  res() {
    this.chiparray = [];
    this.searchForm.controls["session"].setValue(
      this.storageService.getCurrentSession(this.sessionData)?.session
    );
    this.findedVal = this.sessionData?.find(
      (list) => list.session === this.searchFormCtrl["session"]?.value
    ) || null;
    this.chiparray.push(
      "Session : " + this.searchForm.controls["session"]?.value
    ); 
    if (this.storageService.getRole() == 4 && this.ishod == 1) {
      var dept = this.dept.filter((x) => x.id == this.department_id);
      this.chiparray.push("Dept:" + " " + dept[0].name);
      this.professor_id = null;
    }
      if (this.storageService.getRole() == 4 && this.ishod != 1) {
      var proff = this.professorData.filter((x) => x.id == this.professor_id);
      this.chiparray.push("Proff:" + " " + proff[0].first_name + " " + proff[0].last_name);
      this.department_id = null;
      }
    if (this.storageService.getRole() != 4 ) {
      this.professor_id = null;
      this.department_id = null;
    }
    this.filter_from = null;
    this.filter_end = null;
    this.isAudiable = null;
    this.audio_availability = null;
    this.video_message = null;
    this.error_message = null;
    this.batch_id = null;
    this.subject_id =  null;
    this.classroom_id = null;
    this.currentPage = 1;
    this.searchForm.reset();
    this.getVideoDetails();
  }
  paginationCount(value) {
    this.currentPage = 1;
    if (value >= 5) {
      this.page_size = value;
    }
    this.getVideoDetails();
  }
  checkNumeric(value) {
    this.audio_availability = this.searchForm.controls.audio_availability.value;
    if (this.audio_availability == null) {
      this.audio_availability = "";
    }
    if (value % 1 != 0) {
      this.isNonNumeric = true;
      this.audio_availability = "";
      this.numericError = true;
    } else {
      this.isNonNumeric = false;
      this.numericError = false;
    }
  }
}
